module.exports = __webpack_public_path__ + "static/media/logo-afds.951b14c4.png";